import { createContext, useContext } from 'react';
import { WixPatternsInitialProps } from '../model';

const Context = createContext<WixPatternsInitialProps>({});
export const WixPatternsInitialPropsProvider = Context.Provider;
export const useWixPatternsInitialProps = () => useContext(Context);
